import React from 'react';
import styled from 'styled-components';

import ceremony from '../../assets/images/ceremonia.jpg';
import logo from '../../assets/images/logo.png';
import { Text } from '../Text/Text';
import {
  AboutContent,
  AboutContentWrapper,
  AboutMain,
  Image,
  ImageWrapper,
  Wrapper,
} from './about.styles';

const AboutTextDescription = styled(Text)`
  line-height: 150%;
`;

function About() {
  return (
    <Wrapper id='About'>
      <Text elementName='componentTitle' align='center'>
        Kim jesteśmy?
      </Text>

      <AboutMain>
        <ImageWrapper>
          <Image src={logo} alt='' />
        </ImageWrapper>

        <AboutContentWrapper>
          <AboutContent>
            <AboutTextDescription elementName='description'>
              Pogotowie pogrzebowe <b>Anna i Krzysztof Kokot</b> to firma
              rodzinna zajmująca się kompleksową, profesjonalną organizacją
              pogrzebów tradycyjnych i pogrzebów z kremacją. Swoje usługi
              świadczy na terenie Jastrzębia-Zdroju i całego powiatu od{' '}
              <b>1997</b> roku.
            </AboutTextDescription>

            <AboutTextDescription elementName='description'>
              Firma przykłada dużą wagę do
              <b> doboru rzetelnego i profesjonalnego personelu</b>. Zespół
              składa się z osób kulturalnych i życzliwych, które dołożą
              wszelkich starań, aby uroczystość została przeprowadzona z
              godnością i szacunkiem. Posiada bogate zaplecze techniczne, które
              zapewnia najwyższą jakość świadczonych usług.
            </AboutTextDescription>

            <AboutTextDescription elementName='description'>
              Dbając o wysoką jakość Naszych Usług Pogrzebowych zostaliśmy
              członkami <b>Polskiej Izby Przedsiębiorców Branży Pogrzebowej</b>.
            </AboutTextDescription>

            <AboutTextDescription elementName='description'>
              Dla potrzeb Naszych Klientów działamy <b>24 godziny na dobę</b>.
            </AboutTextDescription>
          </AboutContent>
        </AboutContentWrapper>
      </AboutMain>

      <AboutMain>
        <ImageWrapper>
          <Image src={ceremony} alt='' />
        </ImageWrapper>

        <AboutContentWrapper>
          <AboutContent>
            <AboutTextDescription elementName='description'>
              Firma Anna i Krzysztof Kokot stara się zawsze wychodzić naprzeciw
              oczekiwaniom swoich klientów dlatego każdą ceremonię pogrzebową,
              traktuje w sposób wyjątkowy i indywidualny. Każdy człowiek
              zwracający się o pomoc do Firmy Państwa Kokot zostanie otoczony
              opieką, pracownicy pomogą mu przejść przez wszystkie etapy
              organizacji pogrzebu. Służą wszelką pomocą w dopełnieniu
              formalności związanych{' '}
              <b>z Zakładem Ubezpieczeń Społecznych, Urzędem Stanu Cywilnego</b>
              czy szpitalem. Firma oferuje organizację uroczystości pogrzebowych
              <b>we wszystkich obrządkach wyznaniowych</b>.
            </AboutTextDescription>

            <AboutTextDescription elementName='description'>
              Proponuje pogrzeby prowadzone w różnych{' '}
              <b>tradycjach religijnych</b> jak również organizuje{' '}
              <b>uroczystości świeckie</b>, prowadzone przez mistrza ceremonii.
              Każdy klient może liczyć na wsparcie i fachową poradę otrzymaną od
              pracowników, którzy dołożą wszelkich starań, aby ta ważna dla
              niego uroczystość była zorganizowana godnie, niezależnie od
              środków finansowych, jakimi dysponuje. W zakładzie pogrzebowym
              znajdziemy ofertę szerokiego wyboru trumien (dębowych, olchowych
              czy sosnowych), urn (drewnianych, ceramicznych, mosiężnych), a
              także krzyży, tabliczek nagrobnych i trumien kremacyjnych.
            </AboutTextDescription>
          </AboutContent>
        </AboutContentWrapper>
      </AboutMain>
      <AboutMain>
        <AboutContentWrapper oneElement={true}>
          <AboutContent>
            <AboutTextDescription elementName='description'>
              Wykwalifikowani pracownicy firmy zajmą się{' '}
              <b>transportem zwłok</b> z dowolnego miejsca w kraju. Istnieje
              także możliwość zorganizowania transportu międzynarodowego.
              Transport odbywa się z krajów Unii Europejskiej do Polski oraz z
              Polski za granicę. W Polsce zwłoki są przewożone do znajdującej
              się w zakładzie nowoczesnej chłodni. Pracownicy z pełnym
              szacunkiem zajmą się także przygotowaniem ciała do pogrzebu,
              toaletą pośmiertną, ubieraniem i kosmetyką. Firma zapewnia także
              usługi studia florystycznego, oferuje kwiaty cięte, wieńce, palmy,
              wiązanki oraz wiązanki okolicznościowe. Doświadczone florystki
              mają do dyspozycji świeże kwiaty wszystkich gatunków dostępnych na
              polskim rynku. Obecnie coraz bardziej popularna staje się
              kremacja. <b>Zakład Pogrzebowy Anna i Krzysztof Kokot</b>{' '}
              współpracuje z renomowanymi krematoriami i posiada doświadczenie w
              organizacji oraz obsłudze ceremonii pogrzebowych tego typu. Osoba
              zmarła przygotowywana jest do kremacji tak samo, jak do pogrzebu
              tradycyjnego. Ciało składa się w specjalnej ekologicznej bądź
              drewnianej, nielakierowanej trumnie. Natomiast po kremacji prochy
              osoby zmarłej umieszczane są w urnie, którą mogą Państwo wybrać z
              bogatej oferty. Zakład prowadzi także{' '}
              <b>pochówki Dzieci Nienarodzonych</b>. Dzięki doświadczeniu w
              organizacji tego typu pogrzebów zapewnia rodzinie odpowiednie
              wsparcie i pomoc w uzyskaniu niezbędnych dokumentów. Decydując się
              na wybór usług Firmy Anna i Krzysztof Kokot mamy także możliwość
              skorzystania z usług profesjonalnego fotografa, który w dyskretny
              sposób uwieczni dla nas wydarzenie, jakim jest pogrzeb bliskiej
              osoby. Firma oferuje także <b>pogrzeby online</b>. Z tego typu
              transmisji korzysta coraz więcej osób, które z różnych przyczyn
              nie mogą osobiście pożegnać osoby zmarłej. Zlecając organizację
              ceremonii <b>Firmie Anna i Krzysztof Kokot</b>, otrzymacie Państwo
              gwarancję usług najwyższej jakości oraz możliwość zrealizowania
              niestandardowych oczekiwań dotyczących usług pogrzebowych.
            </AboutTextDescription>
          </AboutContent>
        </AboutContentWrapper>
      </AboutMain>
    </Wrapper>
  );
}

export { About };
